import { useTranslation } from 'react-i18next';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import { BUTTON_VARIANT } from 'constants/interfaces';

import TableMAQuestion
  from '../../../components/TableMaterialityAssessmentQuestion/TableMAQuestion';

import type IMaterialAssessmentSurveyCreationView from './interfaces/IMaterialAssessmentSurveyCreationView';

import styles from './scss/MaterialAssessmentSurveyCreation.module.scss';

function MaterialityAssessmentSurveyCreationView({
  isEmptyList,
  loading,
  handleCreateSurvey,
  handleNextSurvey,
  handleCancelSurvey,
  handlePrevSurvey,
  control,
  onSortChange,
  onGetMoreItems,
  itemsList,
  hasNext,
  onEdit,
  onDelete,
  onViewMode,
  isViewOnly,
}: IMaterialAssessmentSurveyCreationView) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleSurvey')}</span>
      <div className={styles.rootContainer}>
        <div className={styles.titleWrapper}>
          <div className={styles.titleWrapperContent}>
            <p>{t('materialityAssessment.creation')}</p>
            <p>{t('materialityAssessment.descriptionCreation')}</p>
          </div>
          {!isEmptyList ? (
            <Button
              title={t('common.addNew')}
              onClick={handleCreateSurvey}
              startIcon={<PlusIcon />}
              disabled={isViewOnly}
            />
          ) : null}
        </div>
        <div className={styles.contentWrapper}>
          {isEmptyList ? (
            <EmptyTaskManagement
              title={t('materialityAssessment.emptySurveysTable')}
              buttonTitle={t('materialityAssessment.createSurvey')}
              buttonOnClick={handleCreateSurvey}
              disabledButton={isViewOnly}
            />
          ) : (
            <TableMAQuestion
              questionProps={{
                control,
                items: itemsList,
                isLoading: loading,
                hasMore: hasNext,
                loadMoreQuestions: onGetMoreItems,
                onSortChange,
                onEdit,
                onDelete,
                onViewMode,
              }}
              disableActions={isViewOnly}
            />
          )}
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={handleCancelSurvey}
            disabled={isViewOnly}
          />
          <div className={styles.rightButtons}>
            <Button
              title={t('common.prev')}
              onClick={handlePrevSurvey}
              variant={BUTTON_VARIANT.cancel}
              className={styles.prevButton}
              disabled={isViewOnly}
            />
            <Button
              title={t('common.next')}
              onClick={handleNextSurvey}
              className={styles.button}
              disabled={isViewOnly}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaterialityAssessmentSurveyCreationView;
